/**
 * Card Spotlight Effect
 * Creates a mouse-tracking glow effect on product cards and buttons
 */

(function() {
  'use strict';

  // Prevent duplicate initialization if this script is included multiple times
  if (window.__cardSpotlightLoaded) return;
  window.__cardSpotlightLoaded = true;

  /**
   * Initialize spotlight effect for all cards with the .card-spotlight class
   */
  function initSpotlightEffect() {
    // Initialize cards
    const cards = document.querySelectorAll('.card-spotlight');
    
    cards.forEach(function(card) {
      // Skip if already initialized
      if (card.dataset.spotlightInit) return;
      card.dataset.spotlightInit = 'true';
      
      card.addEventListener('mousemove', handleMouseMove);
      card.addEventListener('mouseenter', handleMouseEnter);
      card.addEventListener('mouseleave', handleMouseLeave);
    });

    // Initialize buttons inside spotlight cards
    const buttons = document.querySelectorAll('.card-spotlight .quick-add__submit');
    
    buttons.forEach(function(button) {
      // Skip if already initialized
      if (button.dataset.spotlightInit) return;
      button.dataset.spotlightInit = 'true';
      
      button.addEventListener('mousemove', handleMouseMove);
      button.addEventListener('mouseenter', handleMouseEnter);
      button.addEventListener('mouseleave', handleMouseLeave);
    });
  }

  /**
   * Handle mouse movement - update CSS variables for spotlight position
   * @param {MouseEvent} e 
   */
  function handleMouseMove(e) {
    const rect = this.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
    
    this.style.setProperty('--mouse-x', x + 'px');
    this.style.setProperty('--mouse-y', y + 'px');
  }

  /**
   * Handle mouse enter - show spotlight
   * @param {MouseEvent} e 
   */
  function handleMouseEnter(e) {
    this.style.setProperty('--spotlight-opacity', '1');
  }

  /**
   * Handle mouse leave - hide spotlight
   * @param {MouseEvent} e 
   */
  function handleMouseLeave(e) {
    this.style.setProperty('--spotlight-opacity', '0');
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSpotlightEffect);
  } else {
    initSpotlightEffect();
  }

  // Re-initialize when Shopify section is rendered (for theme editor compatibility)
  document.addEventListener('shopify:section:load', initSpotlightEffect);
  
  // Also observe for dynamically added cards (infinite scroll, AJAX, etc.)
  if (typeof MutationObserver !== 'undefined') {
    const observer = new MutationObserver(function(mutations) {
      let shouldInit = false;
      mutations.forEach(function(mutation) {
        if (mutation.addedNodes.length > 0) {
          shouldInit = true;
        }
      });
      if (shouldInit) {
        initSpotlightEffect();
      }
    });

    // Start observing once DOM is ready
    function startObserver() {
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', startObserver);
    } else {
      startObserver();
    }
  }
})();

